import type { PreparedBarometerAuction } from '@autobid/ui/types/components/AuctionsData'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionSocket'
import { singleAuctionQueryKey } from '@autobid/ui/composables/useAuction'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionAuctionFinish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionFinish = () => {
    startListen({
      eventName: 'premium.AUCTION_FINISH',
      callbackName: AUCTION_SOCKET_CALLBACK,
      callback: (event) => {
        const queryKey = singleAuctionQueryKey.byAuctionId(event.context.auctionId)

        queryClient.setQueriesData(queryKey, (data?: PreparedBarometerAuction): PreparedBarometerAuction | undefined => {
          if (!data)
            return data

          return {
            ...data,
            stage: 'FINISHED',
          }
        })
      },
    })
  }

  return { auctionFinish }
}
